import moment from 'moment';

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // y is 8, 9, A, or B
    return v.toString(16);
  });
};

const toMoment = (timestamp: { _seconds: number; _nanoseconds: number }) => {
  return moment(timestamp?._seconds * 1000 + Math.floor(timestamp?._nanoseconds / 1e6));
};

export const sortMessagesAsc = (messages: any[]) => {
  return [...messages].sort((a, b) => {
    return toMoment(a?.timestamp).valueOf() - toMoment(b?.timestamp).valueOf();
  });
};

export const sortMessagesDesc = (messages: any[]) => {
  return [...messages].sort((a, b) => {
    return toMoment(b?.timestamp).valueOf() - toMoment(a?.timestamp).valueOf();
  });
};
